export const selectEmployee = (store) => store.employeeSlice.employee;
export const selectUser = (store) => store.userSlice.user;
export const selectUserRoles = (store) => store.userRoleSlice.userRole;
export const selectSessionConfig = (store) =>
  store.sessionConfigSlice.sessionConfig;
export const selectQuoteApprovalDetails = (store) =>
  store.quoteApprovalDetailsSlice.quoteApprovalDetails;
export const selectReqtCategoryList = (store) =>
  store.reqtCategoryListSlice.reqtCategoryList;
export const selectLocationList = (store) =>
  store.locationListSlice.locationList;
export const selectIcabsProductList = (store) =>
  store.icabsProductListSlice.icabsProductList;
export const selectIcabsProductDetailList = (store) =>
  store.icabsProductDetailListSlice.icabsProductDetailList;
export const selectInfestationLevellList = (store) =>
  store.infestationLevelListSlice.infestationLevelList;
export const selectIcabsProductCoverList = (store) =>
  store.icabsProductCoverListSlice.icabsProductCoverList;
export const selectPezodeUnitList = (store) =>
  store.pezodeUnitListSlice.pezodeUnitList;
